import {store} from "../store/store";
import axios from "axios";
import jwt from "jsonwebtoken";

function throw_error_object(error) {
    var error_object = {};

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      error_object.response = {
        data: error.response.data,
        status: error.response.status,
      }
    }
    if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      error_object.request = error.request;
    }
    if (error.message) {
      // Something happened in setting up the request that triggered an Error
      error_object.error_message = error.message;
    }
    error_object.config = error.config;
    throw {
      "error": error_object,
    }
}

export const monitoringCan = (action, domain_id, resource) => {
          // guard function to decide whether a given action can be perforrmed
          // given current access token.
          var decoded_token = jwt.decode(store.state.accessToken)
          /* console.log(decoded_token);
          console.log('DEBUG action: ' + action);
          console.log('DEBUG domain: ' + domain);
          console.log('DEBUG resource: ' + resource);
          */

          for (var role_entry of decoded_token["iam:roles"]) {
            // Check if domain matches.  ADMIN of id 0 matches all
            if ((role_entry["domain_id"] == 0 && role_entry["role"] == "ADMIN")
                || (role_entry["domain_id"] == domain_id)) {
                for (var permission of role_entry["permissions"]) {
                    // Check for action match
                    if (permission["action"] == "pernilla:*"
                        || permission["action"] == "pernilla" + action) {
                        // check resource match
                        if ( permission["resource"] == "*"
                           || permission["resource"] == resource) {
                              //console.log('DEBUG permitted');
                              return true;
                        }
                    }
                }
            }

          }
          //console.log('DEBUG forbidden');
          return false;

}

export default class MonitoringService {
    getStatuses() {
      return store.dispatch('getAccessToken').then(token => {
          return axios.get('/monitoring/statuses', {
              headers: {
                  "Authorization": "Bearer " + token,
              }
          }
            ).then(resp => resp).catch(err => err)
      });
    }

    getPanelSizeTimeline(data) {
      return store.dispatch('getAccessToken').then(token => {
          return axios.post('/monitoring/timeline-panel-size', {
              "date": data.date,
              "range": data.range,
            },
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }
        ).then(resp => resp).catch(err => err)
      })
    }

    getCandidatesSizeTimeline(data) {
      return store.dispatch('getAccessToken').then(token => {
          return axios.post('/monitoring/timeline-candidates-size', {
              "date": data.date,
              "range": data.range,
            },
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }
        ).then(resp => resp).catch(err => err)
      })
    }

    getPublishedTweetsPanelTimeline(data) {
      return store.dispatch('getAccessToken').then(token => {
          return axios.post('/monitoring/timeline-published-tweets-panel', {
              "date": data.date,
              "range": data.range,
            },
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }
        ).then(resp => resp).catch(err => err)
      })
    }

    getPublishedTweetsCandidatesTimeline(data) {
      return store.dispatch('getAccessToken').then(token => {
          return axios.post('/monitoring/timeline-published-tweets-candidates', {
              "date": data.date,
              "range": data.range,
            },
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }
          ).then(resp => resp).catch(err => err)
      })
    }

    getAddedUsersTimeline(data) {
      return store.dispatch('getAccessToken').then(token => {
          return axios.post('/monitoring/timeline-added-users', {
              "date": data.date,
              "range": data.range,
            },
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }
          ).then(resp => resp).catch(err => err)
      })
    }

    getRemovedUsersTimeline(data) {
      return store.dispatch('getAccessToken').then(token => {
          return axios.post('/monitoring/timeline-removed-users', {
              "date": data.date,
              "range": data.range,
            },
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }
          ).then(resp => resp).catch(err => err)
      })
    }

    getPanelShareTimeline(data) {
        return store.dispatch('getAccessToken').then(token => {
          return axios.post('/monitoring/timeline-panel-share', {
              "date": data.date,
              "range": data.range,
            },
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }
          ).then(resp => resp).catch(err => err)
      })
    }

    getPanelActivityTimeline(data) {
        return store.dispatch('getAccessToken').then(token => {
          return axios.post('/monitoring/timeline-activity', {
              "date": data.date,
              "range": data.range,
            },
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }
          ).then(resp => resp).catch(err => err)
      })
    }

    getCommunitySizeTimeline(data) {
        return store.dispatch('getAccessToken').then(token => {
          return axios.post('/monitoring/timeline-community-size', {
              "date": data.date,
              "range": data.range,
            },
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }
          ).then(resp => resp).catch(err => err)
      })
    }

    getMonitoringMetrics(data) {
        return store.dispatch('getAccessToken').then(token => {
          return axios.post('/monitoring/timeline-metrics', {
              "date": data.date,
              "range": data.range,
            },
            {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            }
          ).then(resp => resp).catch(err => err)
      })
    }
    // async getTestData() {
    //   return store.dispatch('getAccessToken').then(token => {
    //         return axios.get('/monitoring/test-panel',
    //           {headers: {Authorization: "Bearer " + token}})
    //           .then(resp => resp).catch(err => err)
    //       });
    // }
}
